<div class="sale-dialog" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
	<div class="sd-header" cdkDragHandle>
		<h3 class="sd-title">
			{{data?.roomTypeID === 1 ? 'Коммерческое помещение' : 'Парковочное место'}} № {{data?.place?.placeNumber}}
		</h3>
		<button type="button" class="sd-close" (click)="closeDialog()" aria-label="Close">✕</button>
	</div>

	<div class="sd-body" [formGroup]="form">
		<div class="inputs-wrapper">
			<div class="input-row">
				<div class="input-title">
					Стоимость помещения, тг. <span class="required">*</span>
				</div>
				<input type="text" formControlName="priceAmount" placeholder="Стоимость" class="text-input"
					[mask]="'separator'" />
			</div>
			<div class="input-row">
				<div class="input-title">
					Дата регистрации договора <span class="required">*</span>
				</div>
				<div class="text-input">
					<div class="date-value">
						{{saleDate?.value | date:'dd.MM.yyyy'}}
					</div>
					<app-date-picker [control]="saleDate" [isHidden]="true"></app-date-picker>
				</div>
			</div>
		</div>
		<div class="img" [ngClass]="{'hover': imgHover}">
			<ng-container *ngIf="loadPlan">
				<img alt="" class="img-bg" [src]="imageUrl" (change)="handleFileInput($event)"
					*ngIf="oneFlatDataSet1.fileExtension !== 'pdf'">
				<pdf-viewer [src]="pdfSrc" [render-text]="true" [page]="page" [show-all]="true" style="display: flex;    width: 400px;
				height: 100%;" *ngIf="oneFlatDataSet1.fileExtension === 'pdf'"></pdf-viewer>
			</ng-container>
			<div class="flats-modal-footer" *ngIf="!loadPlan">
				<ng-container>
					<!-- *ngIf="flat_modal_info" -->
					<div class="btn btn-apply-border">Загрузить план
						<input type="file" id="file" (change)="handleFileInput($event)">
					</div>
				</ng-container>
			</div>
		</div>
	</div>

	<div class="sd-footer">
		<button type="button" class="btn btn-apply" (click)="confirm()">Подтвердить</button>
		<button type="button" class="btn btn-cancel" (click)="closeDialog()">Закрыть</button>
		<button type="button" class="btn btn-apply" *ngIf="data?.place?.dbFileID" (click)="deletePlan()">
			Удалить план
		</button>
	</div>
</div>